import React, { memo, useState, useCallback } from 'react'
import { CLAN_SUPPLY_FOOTER_STATUSES, QUEST_STATUSES } from '../clan_quests_constants'
import {
    CLAN_SUPPLY_IN_PROGRESS,
    CLAN_SUPPLY_QUESTS_ALL_DONE,
    CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES,
    CLAN_SUPPLY_QUESTS_TAKE_REWARD,
} from '../../translations'
import styles from './ClanSupplyFooter.scss'
import classNames from 'classnames'
import { Button } from 'react-wot-bootstrap'
import PropTypes from 'prop-types'
import {
    requestToTakeRewards,
    requestClanSupplyQuestsInfo,
    REQUEST_INTERVAL,
} from '../../../../state/actions/clan_supply_quests'
import { useDispatch, useStore } from 'react-redux'
import { setNewsCounter } from 'helpers/web_to_client'
import { CLAN_SUPPLY_HANGAR_BUBBLE_KEY } from 'constants'
import delay from 'helpers/delay'

const expectedStatuses = [
    QUEST_STATUSES.COMPLETE,
    QUEST_STATUSES.COMPLETE,
    QUEST_STATUSES.COMPLETE,
]

const ClanSupplyFooterQuests = memo(({
    previousRewardsSum,
    questsList,
}) => {
    const dispatch = useDispatch()
    const [isButtonClickEnabled, setIsButtonClickEnabled] = useState(true)
    const store = useStore()

    const handleClick = useCallback(async (event) => {
        event.stopPropagation()
        setIsButtonClickEnabled(false)

        await dispatch(requestToTakeRewards())

        const state = store.getState()
        const requestNotPossibleByTimeout = state.clanSupplyQuests.lastRequestTimestamp &&
            (Date.now() - state.clanSupplyQuests.lastRequestTimestamp) < REQUEST_INTERVAL

        if (state.clanSupplyQuests.loading || requestNotPossibleByTimeout) {
            await delay(REQUEST_INTERVAL)
        }
        await dispatch(requestClanSupplyQuestsInfo())

        setNewsCounter(CLAN_SUPPLY_HANGAR_BUBBLE_KEY, 0)
        setIsButtonClickEnabled(true)
    }, [dispatch, requestToTakeRewards, requestClanSupplyQuestsInfo])

    let text = CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES
    let status = CLAN_SUPPLY_FOOTER_STATUSES.DEFAULT
    const statuses = Object.values(questsList).map(item => item.status)
    if (previousRewardsSum > 0 || statuses.includes(QUEST_STATUSES.REWARD_AVAILABLE)) {
        status = CLAN_SUPPLY_FOOTER_STATUSES.TAKE_PRIZE
    } else if (statuses.includes(QUEST_STATUSES.REWARD_PENDING)) {
        text = CLAN_SUPPLY_IN_PROGRESS
    } else if (statuses.every((element, index) => element === expectedStatuses[index])) {
        status = CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS
        text = CLAN_SUPPLY_QUESTS_ALL_DONE
    }

    return (
        <div className={classNames(styles.base, styles[`base__status-${status}`])}>
            {status === CLAN_SUPPLY_FOOTER_STATUSES.TAKE_PRIZE ? (
                <React.Fragment>
                    <Button type='primary' onClick={handleClick} isDisabled={!isButtonClickEnabled}>
                        {CLAN_SUPPLY_QUESTS_TAKE_REWARD}
                    </Button>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    {status === CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS && (
                        <div className={styles.iconStatus} />
                    )}
                    <p className={classNames(
                        styles.text,
                        status === CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS && styles.text__success)}
                    >
                        {text}
                    </p>
                </React.Fragment>
            )}
        </div>
    )
})

ClanSupplyFooterQuests.propTypes = {
    previousRewardsSum: PropTypes.number.isRequired,
    questsList: PropTypes.array.isRequired,
}

export default ClanSupplyFooterQuests



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyFooter/ClanSupplyFooterQuests.jsx